import { HistoryMessageItem, MessageIncomingEvent, MessageOutgoingEvent } from '@wui/im'

import { useLocalization } from '@/shared/composables/localization'
import { Room } from '@/shared/types/store'

import { countMessagesText } from './index'

export type BulkDeletableMessage = HistoryMessageItem<MessageIncomingEvent | MessageOutgoingEvent>
export type BulkDeleteMethod = 'delete' | 'deleteForSelf'

export const isIncomingFromOther = (
  event: BulkDeletableMessage,
  currentUserImLogin?: string,
): boolean => {
  return event.item.type === 'IncomingMessageEvent'
    && event.item.executor !== currentUserImLogin
}

export const isBulkDeletableMessage = (
  event: BulkDeletableMessage | undefined,
  room: Room,
  currentUserImLogin?: string,
): event is BulkDeletableMessage => {
  if (!event?.item) {
    return false
  }

  if (event.item.type === 'OutgoingMessageEvent') {
    return true
  }

  return room.isGroup && isIncomingFromOther(event, currentUserImLogin)
}

export const getBulkDeleteMethod = (event: BulkDeletableMessage): BulkDeleteMethod => {
  return event.item.type === 'OutgoingMessageEvent' ? 'delete' : 'deleteForSelf'
}

export const countBulkDeleteForSelf = (events: BulkDeletableMessage[]): number => {
  return events.filter((event) => getBulkDeleteMethod(event) === 'deleteForSelf').length
}

export const buildBulkDeleteConfirmMessage = (events: BulkDeletableMessage[]): string => {
  const { t } = useLocalization()
  const totalCount = events.length
  const forSelfCount = countBulkDeleteForSelf(events)
  const base = `${t('common.areYouSureYouWantToDelete')} ${countMessagesText(totalCount)}`

  if (forSelfCount === 0) {
    return `${base}?`
  }

  if (forSelfCount === totalCount) {
    return `${base} ${t('chat.deleteSelectedMessagesAllForSelfSuffix')}?`
  }

  return `${base} ${t('chat.deleteSelectedMessagesForSelfSuffix', { count: forSelfCount })}?`
}
